import { useCallback, useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Products from './components/Products';
import Services from './components/Services';
import Cases from './components/Cases';
import Clients from './components/Clients';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';

export default function App() {
  const [contactOpen, setContactOpen] = useState(false);

  const openContact = useCallback(() => setContactOpen(true), []);
  const closeContact = useCallback(() => setContactOpen(false), []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar onContact={openContact} />
      <main>
        <Hero onStart={openContact} />
        <Products onContact={openContact} />
        <Services />
        <Cases onContact={openContact} />
        <Clients />
      </main>
      <Footer />
      <ContactModal open={contactOpen} onClose={closeContact} />
    </div>
  );
}
